import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="py-20 bg-zinc-950" data-id="element-97">
      <div className="container mx-auto px-4" data-id="element-98">
        <div className="max-w-3xl mx-auto bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-99">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-600 to-green-400" data-id="element-100"></div>

          <ShieldCheckIcon className="w-20 h-20 text-green-500 mx-auto mb-6" data-id="element-101" />

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-102">
            🛡️ GARANTÍA DE 7 DÍAS
          </h2>

          <p className="text-xl text-zinc-300 mb-8" data-id="element-103">
            Probalo durante una semana entera.
          </p>

          <div className="text-left bg-zinc-950 p-6 rounded-xl border border-zinc-800 mb-8" data-id="element-104">
            <p className="text-zinc-300 leading-relaxed mb-4" data-id="element-105">
              Si no sentís que tenés más claridad, más confianza y un sistema
              concreto para el próximo sábado:
            </p>
            <p className="text-2xl font-bold text-white text-center" data-id="element-106">
              Te devolvemos el 100% de la guita.
            </p>
          </div>

          <p className="text-zinc-400 mb-8" data-id="element-107">
            Sin preguntas. Sin formularios. Sin vueltas.
          </p>

          <CTAButton text="👉 SÍ, QUIERO EL SISTEMA COMPLETO →" data-id="element-108" />
        </div>
      </div>
    </section>;
}